import { INIT_ERROR_PAYMENT, ERROR_PAYMENT } from "../types/error.types";
import { deepClone } from "../../utils/utils";

const initialState = {
  errorPayment: initError(),
};

const reducer = function orderReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case ERROR_PAYMENT:
      const { response } = action;
      newState.errorPayment.declineCode = response.declineCode;
      newState.errorPayment.message = response.message;
      newState.errorPayment.code = response.code;
      newState.errorPayment.products = response.options ? response.options.products : "";
      newState.errorPayment.error = true;
      return newState;
    case INIT_ERROR_PAYMENT:
      newState.errorPayment = initError();
      return newState;
    default:
      return newState;
  }
};

function initError() {
  return {
    declineCode: "",
    error: false,
    message: "",
    code: "",
    products: ""
  };
}

export default reducer;
